<template>
  <div :class="className">
    <slot />
  </div>
</template>

<script>
import bemBlockModifiers from "@/utils/bem-block-modifiers"

export default {
  name: "Page",
  props: {
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    className() {
      return bemBlockModifiers("page", this.modifiers)
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/shared/page";
</style>
